import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/components/Layout.vue';
import SubLayout from '@/components/SubLayout.vue';
Vue.use(Router);
export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [{
    path: "/",
    name: "login",
    component: function component() {
      return import(/* webpackChunkName: "about" */"@/views/Login.vue");
    }
  }, {
    path: "/result/:status",
    name: "result",
    component: function component() {
      return import(/* webpackChunkName: "about" */"@/views/Alert.vue");
    }
  }, {
    path: "/paymentdate/:p",
    name: "paymentdate",
    component: function component() {
      return import(/* webpackChunkName: "about" */"@/views/PaymentDayChange.vue");
    }
  }, {
    path: "/verifyEmail",
    name: "verifyEmail",
    component: function component() {
      return import(/* webpackChunkName: "about" */"@/views/VerifyEmail.vue");
    }
  }, {
    path: "/appointment/:videokey",
    name: "appointment",
    component: function component() {
      return import(/* webpackChunkName: "about" */"@/views/Appointment.vue");
    }
  }, {
    path: "/kit",
    name: "kit",
    component: function component() {
      return import(/* webpackChunkName: "about" */"@/views/Kit.vue");
    }
  }, {
    path: "/login",
    name: "loginX",
    component: function component() {
      return import(/* webpackChunkName: "about" */"@/views/Login.vue");
    }
  }, {
    path: "",
    component: Layout,
    name: "Home",
    redirect: "home",
    children: [{
      path: "",
      component: SubLayout,
      name: "Home",
      redirect: "home",
      children: [{
        path: "/home",
        name: "home",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/Home.vue");
        }
      }, {
        path: "/references",
        name: "references",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/References.vue");
        }
      }, {
        path: "/successpayment",
        name: "successpayment",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/SuccessPayment.vue");
        }
      }, {
        path: "/failpayment/:errorMessage",
        name: "failpayment",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/FailPayment.vue");
        }
      }, {
        path: "/campaign",
        name: "campaign",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/Campaigns.vue");
        }
      }, {
        path: "/campaign/detail/:campaignDefinitionId",
        name: "campaign-detail",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/CampaignDetail.vue");
        }
      }, {
        path: "/customer-representative",
        name: "customer-representative",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/CustomerRepresentative.vue");
        }
      }, {
        path: "/notifications",
        name: "notifications",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/Notifications.vue");
        }
      }, {
        path: "/project-detail/:calculationId",
        name: "project-detail",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/ProjectDetail.vue");
        }
      }, {
        path: "/payment",
        name: "payment",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/Payment.vue");
        }
      }, {
        path: "/skip-installment",
        name: "skip-installment",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/SkipInstallment.vue");
        }
      }, {
        path: "/messages",
        name: "messages",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/Messages.vue");
        }
      }, {
        path: "/faqs",
        name: "faqs",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/Faqs.vue");
        }
      }, {
        path: "/payment-information",
        name: "payment-information",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/PaymentInformation.vue");
        }
      }, {
        path: "/my-account",
        name: "my-account",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/Account.vue");
        }
      }, {
        path: "/last-movements",
        name: "last-movements",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/LastMovements.vue");
        }
      }, {
        path: "/prize-detail",
        name: "prize-detail",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/PrizeDetail.vue");
        }
      }, {
        path: "/prize-detail2",
        name: "prize-detail2",
        component: function component() {
          return import(/* webpackChunkName: "about" */"@/views/PrizeDetail2.vue");
        }
      }]
    }, {
      path: "/map",
      name: "map",
      component: function component() {
        return import(/* webpackChunkName: "about" */"@/views/Map.vue");
      }
    }, {
      path: "/my-groups",
      name: "my-groups",
      component: function component() {
        return import(/* webpackChunkName: "about" */"@/views/MyGroups.vue");
      }
    }, {
      path: "/referenceApproval",
      name: "referenceApproval",
      component: function component() {
        return import(/* webpackChunkName: "about" */"@/views/ReferenceApproval.vue");
      },
      meta: {
        headerClass: "none"
      }
    }, {
      path: "/permissionUpdate",
      name: "permissionUpdate",
      component: function component() {
        return import(/* webpackChunkName: "about" */"@/views/permission/PermissionUpdate.vue");
      },
      meta: {
        headerClass: "none"
      }
    }, {
      path: '/customerSave/:formId',
      name: 'customerSave',
      component: function component() {
        return import(/* webpackChunkName: "about" */'@/views/CustomerSave.vue');
      },
      meta: {
        headerClass: 'none',
        topBarClass: 'none',
        popupClass: 'none'
      }
    }]
  }]
});